Ext.define('SA.view.legend.CategoryOptions', {
    alias: 'widget.legend-category-options',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-legend-category',
    customColors: [],

    colorsTpl: new Ext.XTemplate(
        '<span class="sa-legend-color-scheme-wrap">',
            '<tpl for=".">',
                '<span class="sa-legend-color-scheme-color" style="background:#{.};"></span>',
            '</tpl>',
        '</span>'
    ),

    items: [
        {
            xtype: 'component',
            cls: 'sa-legend-edit-control-label',
            html: 'Classification Method',
            margin: '8 18 0'
        }, {
            xtype: 'combo-button',
            emptyText: '\u00a0',
            itemId: 'classificationMethod',
            margin: '5 14',

            items: [
                'Quantiles (Local)',
                'Quantiles (National)',
                'Natural Breaks (Local)',
                'Natural Breaks (National)',
                'Equal Intervals',
                'Custom'
            ],

            selectHandler(method) {
                var map = this.up('map-legend').map,
                    settings = map.getLegendSettings(),
                    classificationMethod = method.replace(/ \(.*\)$/, ''),
                    extent = method.includes('Local') ? map.getExtent().toXYBounds() : null;

                if (classificationMethod === 'Custom') {
                    classificationMethod = 'custom';
                }

                if (settings.classificationMethod !== classificationMethod || !settings.extent !== !extent) {
                    map.setLegend({classificationMethod, extent});
                }
            },

            showMenu() {
                var menu = this.getMenu(),
                    isDark = this.up('map-legend').hasCls('sa-legend-dark');

                menu.ifCls(isDark, 'sa-legend-menu-dark');
                menu.ifCls(!isDark, 'sa-legend-menu-light');

                return this.self.prototype.showMenu.apply(this, arguments);
            }
        }, {
            xtype: 'simple-container',
            margin: '5 14',

            items: [
                {
                    xtype: 'component',
                    cls: 'sa-legend-edit-control-label',
                    html: 'Number of Categories',
                    margin: '0 4 5'
                }, {
                    xtype: 'combo-button',
                    emptyText: '\u00a0',
                    flex: 1,
                    itemId: 'numberOfCategories',
                    items: [2, 3, 4, 5, 6, 7, 8, 9],
                    width: '100%',

                    selectHandler(numberOfRanges) {
                        var map = this.up('map-legend').map;

                        if (map.getLegendSettings().numberOfRanges !== numberOfRanges) {
                            map.setLegend({numberOfRanges});
                        }
                    },

                    showMenu() {
                        var menu = this.getMenu(),
                            isDark = this.up('map-legend').hasCls('sa-legend-dark');

                        menu.ifCls(isDark, 'sa-legend-menu-dark');
                        menu.ifCls(!isDark, 'sa-legend-menu-light');

                        return this.self.prototype.showMenu.apply(this, arguments);
                    }
                }
            ]
        }, {
            xtype: 'simple-container',
            margin: '5 14 0',

            items: [
                {
                    xtype: 'component',
                    cls: 'sa-legend-edit-control-label',
                    margin: '0 4 5',
                    renderTpl: '{[SA.localize("Color Scheme")]}'
                }, {
                    xtype: 'sa-menu-button',
                    cls: 'sa-legend-color-scheme-menu-button sa-legend-menu-button-transparent',
                    flex: 1,
                    htmlEncode: false,
                    itemId: 'colorScheme',
                    text: '\u00a0',
                    width: '100%',

                    menu: {
                        defaults: {
                            handler(item) {
                                if (item.hasCls('sa-legend-selected-colors')) {
                                    return;
                                }

                                var scheme = item.name,
                                    colors = item.colors,
                                    map = item.up('map-legend').map,
                                    legend = map.getLegendBreaks();

                                if (legend.colorScheme === 'custom') {
                                    item.up('legend-category-options').addCustomColors(legend.colors);
                                }

                                item.up('sa-menu-button').setText(item.text);

                                map.setLegend(
                                    scheme === 'custom' ? {colors} : {colorScheme: scheme}
                                );
                            }
                        }
                    },

                    showMenu() {
                        var menu = this.getMenu(),
                            isDark = this.up('map-legend').hasCls('sa-legend-dark');

                        menu.ifCls(isDark, 'sa-legend-menu-dark');
                        menu.ifCls(!isDark, 'sa-legend-menu-light');

                        return this.self.prototype.showMenu.apply(this, arguments);
                    }
                }
            ]
        }
    ],

    addCustomColors(colors) {
        this.customColors = this.deduplicateCustomColorSchemes(this.customColors.concat({
            colors,
            name: 'custom'
        }));
    },

    beforeShow() {
        this.callParent();

        this.refresh();
    },

    deduplicateCustomColorSchemes(schemes) {
        var hash = {},
            newSchemes = [];

        schemes.forEach(scheme => {
            var key = scheme.colors.join(',').toLowerCase();

            if (!hash[key]) {
                newSchemes.push(scheme);
            }

            hash[key] = true;
        });

        return newSchemes;
    },

    refresh() {
        var classificationMethodBtn = this.down('#classificationMethod'),
            numberOfCategoriesBtn = this.down('#numberOfCategories'),
            colorSchemeBtn = this.down('#colorScheme'),
            legendView = this.up('map-legend'),
            map = legendView.map,
            legendSettings = map.getLegendSettings(),
            legendBreaks = map.getLegendBreaks(),
            colorsTpl = this.colorsTpl,
            customColors = this.customColors,
            schemes = [],
            separator = false,
            classificationMethod, currentColors, currentSchemeName, colorsMenu;

        Ext.suspendLayouts();

        if (legendSettings) {
            classificationMethod = legendSettings.classificationMethod;

            if (classificationMethod === 'custom') {
                classificationMethod = 'Custom';
            }
            else if (legendSettings.extent) {
                classificationMethod += ' (Local)';
            }
            else if (classificationMethod !== 'Equal Intervals') {
                classificationMethod += ' (National)';
            }

            classificationMethodBtn.setValue(classificationMethod);
            numberOfCategoriesBtn.setValue(legendSettings.numberOfRanges);
        }

        if (legendBreaks) {
            currentColors = legendBreaks.colors;
            currentSchemeName = legendBreaks.colorScheme;

            colorSchemeBtn.setText(colorsTpl.apply(currentColors));

            colorsMenu = colorSchemeBtn.getMenu();

            colorsMenu.removeAll();

            if (currentSchemeName === 'custom') {
                customColors = this.deduplicateCustomColorSchemes(customColors.concat({
                    colors: currentColors,
                    name: 'custom'
                }));
            }

            SA.data.ColorScheme.all.forEach(scheme => {
                schemes.push({
                    colors: scheme[legendBreaks.numberOfRanges],
                    name: scheme.name
                });
            });

            customColors.forEach(scheme => {
                if (scheme.colors.length === legendBreaks.numberOfRanges) {
                    if (!separator) {
                        schemes.push('-');
                        separator = true;
                    }

                    schemes.push(scheme);
                }
            });

            colorsMenu.add(schemes.map(scheme => {
                if (scheme === '-') {
                    return {
                        xtype: 'menuseparator'
                    };
                }

                return {
                    cls: scheme.name === currentSchemeName && Ext.Array.equals(scheme.colors, currentColors) ? 'sa-legend-selected-colors' : '',
                    colors: scheme.colors,
                    encodeText: false,
                    name: scheme.name,
                    text: colorsTpl.applyTemplate(scheme.colors)
                };
            }));
        }

        Ext.resumeLayouts(true);
    }
});